import * as React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = (theme) => ({
  calculatingContainer: {
    position: "fixed",
    width: "100%",
    height: "100%",
    background: `rgba(0, 0, 0, 0.4)`,
    top: 0,
    left: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    zIndex: 9999,
    color: theme.palette.common.white,
  },
  calculating: {
    color: theme.palette.common.white,
  },
});

const Calculating = (props) => {
  return (
    <div className={props.classes.calculatingContainer}>
      <CircularProgress className={props.classes.calculating} />
      Calculating...
    </div>
  );
};

Calculating.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Calculating);



// WEBPACK FOOTER //
// ./src/components/Loading/Calculating.jsx